var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-error-message-container",class:(_vm.displaySegmentError)?'show':''},[_c('span',[_vm._v(_vm._s(_vm.errorMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }